import { Injectable } from '@angular/core';
import { EmojiSearch } from '@ctrl/ngx-emoji-mart';

import { PALAVRAS_PT } from '../../chat/utils/emoji-busca-pt.constantes';

@Injectable()
export class EmojiBuscaPtService extends EmojiSearch {
  override buildSearch(shortNames: string[], name: string, id: string, keywords: string[], emoticons: string[]): string {
    const base = super.buildSearch(shortNames, name, id, keywords, emoticons);
    const extras = new Set<string>();
    for (const termo of base.split(',')) {
      const pt = PALAVRAS_PT[termo];
      if (pt) pt.split(' ').forEach(p => extras.add(p));
    }
    return extras.size ? `${base},${[...extras].join(',')}` : base;
  }
}
